
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_op-oost",
      function () {
        return require("private-next-pages/_sites/_op-oost/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_op-oost"])
      });
    }
  